import type { DocumentAudioManifest } from '../types/document.types'

export function needsAudioRefresh(manifest: DocumentAudioManifest | null): boolean {
  return Boolean(manifest?.tracks.some(track => ['unavailable', 'waiting', 'queued', 'generating'].includes(track.status)))
}

/** Polling must not restart playback; new text or a different revision must get a fresh URL. */
export function mergeAudioManifest(previous: DocumentAudioManifest | null, next: DocumentAudioManifest): DocumentAudioManifest {
  if (previous?.version_id !== next.version_id) return next

  return {
    ...next,
    tracks: next.tracks.map(track => {
      const old = previous.tracks.find(item => item.kind === track.kind)
      if (old?.generation && old.generation === track.generation && old.file && track.file)
        return { ...track, file: { ...track.file, url: old.file.url } }

      return track
    }),
  }
}
